import { LinkLabelCategory } from 'src/containers/ProjectDiagram/constants/categories';
import {
  DeletedModelConceptHierarchyLabel,
  ModelConceptHierarchyLabel,
} from 'src/containers/ProjectDiagram/types/data';
import { replaceDeletedModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createDeletedModelConceptClass';

export const replaceDeletedModelConceptHierarchyLabelKey = (key: string) =>
  key.replace(
    new RegExp(`^${LinkLabelCategory.MODEL_CONCEPT_HIERARCHY_LABEL}-`),
    `${LinkLabelCategory.DELETED_MODEL_CONCEPT_HIERARCHY_LABEL}-`
  );

export const createDeletedModelConceptHierarchyLabel = (
  existing: ModelConceptHierarchyLabel,
  deletedKeys: Set<string>
): DeletedModelConceptHierarchyLabel => ({
  key: replaceDeletedModelConceptHierarchyLabelKey(existing.key),
  from: deletedKeys.has(existing.from)
    ? replaceDeletedModelConceptClassKey(existing.from)
    : existing.from,
  value: existing.value,
  to: deletedKeys.has(existing.to)
    ? replaceDeletedModelConceptClassKey(existing.to)
    : existing.to,
  category: LinkLabelCategory.DELETED_MODEL_CONCEPT_HIERARCHY_LABEL,
});
